import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/administration/_administration/discipline/_discipline')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.disciplines' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
